export class TrackingData {
  Category: string;
  Action: string;
  Label: string;
  UserId: number;
}
